import { useQuery } from '@tanstack/react-query';
import { PermissionAssignmentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionAssignmentsControllerListAssignmentsQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['permissionAssignmentsControllerListAssignments', accessControlScope, args],
        queryFn: async () => {
            const api = new PermissionAssignmentsApi(accessControlConfig);
            return api.permissionAssignmentsControllerListAssignments(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionAssignmentsControllerListAssignmentsQuery.js.map